import { HashtagIcon } from "@heroicons/react/24/outline"

/**
 * Identifiers extension (admin side): the product's SKU and EAN, edited in
 * the Information tab (the project's `product-info` extension), or in Details
 * where there is none — `extends` puts the fields into that tab instead of a
 * tab of their own. The server half is
 * aldoo-na/store/product/extensions/identifiers (the sku is unique).
 */
export const StoreProductExtension = {
  id: "identifiers",
  label: "Identifiers",
  description: "The product's SKU and EAN, in the Information tab",
  icon: HashtagIcon,
  extends: ["product-info", "details"],
  fields: [
    { id: "sku", label: "SKU", type: "Text", description: "The store's code of the product (unique)", render: { variant: "default" } },
    { id: "ean", label: "EAN", type: "Text", description: "The barcode (EAN-13 / UPC)", render: { variant: "default" } },
  ],
}
